module.exports = __webpack_public_path__ + "static/media/103.fb21d15d.svg";